import { motion } from "framer-motion";
import { useSelector, useDispatch } from "react-redux";
import { toggleLanguage } from "../store/features/languageSlice";

const LanguageToggle = () => {
  const lang = useSelector((state) => state.language.lang);
  const dispatch = useDispatch();

  const isEN = lang === "en";

  return (
    <button
      onClick={() => dispatch(toggleLanguage())}
      className="flex items-center gap-1 rounded-full transition-all duration-300"
    >
      {/* EN */}
      <div className="relative group">
        <motion.img
          src="/maria/uk.png"
          alt="English"
          animate={{
            scale: isEN ? 1 : 0.92,
            opacity: isEN ? 1 : 0.45,
          }}
          transition={{ duration: 0.25 }}
          className={`
        w-5 h-5 rounded-full object-cover
        transition-all duration-300
        ${!isEN ? "grayscale" : ""}
      `}
        />

        <span
          className="
        absolute left-1/2 -translate-x-1/2
        -top-9
        px-2 py-1
        rounded-md
        bg-black
        text-white
        text-[10px]
        whitespace-nowrap
        opacity-0
        group-hover:opacity-100
        transition-all duration-200
        pointer-events-none
      "
        >
          English
        </span>
      </div>

      <div className="h-4 w-px bg-gray-200" />

      {/* VI */}
      <div className="relative group">
        <motion.img
          src="/maria/vn.png"
          alt="Vietnamese"
          animate={{
            scale: !isEN ? 1 : 0.92,
            opacity: !isEN ? 1 : 0.45,
          }}
          transition={{ duration: 0.25 }}
          className={`
        w-5 h-5 rounded-full object-cover
        transition-all duration-300
        ${isEN ? "grayscale" : ""}
      `}
        />

        <span
          className="
        absolute left-1/2 -translate-x-1/2
        -top-9
        px-2 py-1
        rounded-md
        bg-black
        text-white
        text-[10px]
        whitespace-nowrap
        opacity-0
        group-hover:opacity-100
        transition-all duration-200
        pointer-events-none
      "
        >
          Tiếng Việt
        </span>
      </div>
    </button>
  );
};

export default LanguageToggle;

// import { motion } from "framer-motion";
// import { useSelector, useDispatch } from "react-redux";
// import { toggleLanguage } from "../store/features/languageSlice";

// const LanguageToggle = () => {
//   const lang = useSelector((state) => state.language.lang);
//   const dispatch = useDispatch();

//   const isEN = lang === "en";

//   return (
//     <div className="flex items-center gap-2 rounded-full px-2 py-1 text-xs">
//       <div
//         onClick={() => dispatch(toggleLanguage())}
//         className="relative w-20 h-9 cursor-pointer rounded-full bg-none border-0 border-gray-400 flex items-center px-1 overflow-hidden"
//       >
//         {/* SLIDING INDICATOR */}
//         <motion.div
//           layout
//           transition={{
//             type: "spring",
//             stiffness: 420,
//             damping: 28,
//             mass: 0.6,
//           }}
//           className="absolute top-1 h-7 w-9 rounded-full bg-neonYellow shadow-[0_0_12px_rgba(230,255,26,0.6)]"
//           style={{
//             left: isEN ? "4px" : "40px",
//           }}
//         />

//         {/* LABELS */}
//         <div className="relative z-10 flex items-center justify-between w-full px-2">
//           <motion.div
//             animate={{
//               scale: isEN ? 1.05 : 0.95,
//               opacity: isEN ? 1 : 0.6,
//             }}
//             transition={{ duration: 0.25 }}
//           >
//             <img
//               src="/maria/uk.png"
//               alt="English"
//               className={`
//         w-5 h-5 rounded-full object-cover
//         transition-all duration-300
//         ${!isEN ? "grayscale" : ""}
//       `}
//             />
//           </motion.div>

//           <motion.div
//             animate={{
//               scale: !isEN ? 1.05 : 0.95,
//               opacity: !isEN ? 1 : 0.6,
//             }}
//             transition={{ duration: 0.25 }}
//           >
//             <img
//               src="/maria/vn.png"
//               alt="Vietnamese"
//               className={`
//         w-5 h-5 rounded-full object-cover
//         transition-all duration-300
//         ${isEN ? "grayscale" : ""}
//       `}
//             />
//           </motion.div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default LanguageToggle;
